import { OwnerType, OWNER_TYPES_OBJ } from "types"

const getIsOwnerType = (v: unknown): v is OwnerType =>
  typeof v === 'string' &&
  v in OWNER_TYPES_OBJ

export default getIsOwnerType
